var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedoNonactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2283 0.905382L31.9966 10.1779C32.5826 10.5726 32.5857 11.434 32.0025 11.8328L18.2342 21.2486C17.5705 21.7025 16.6697 21.2272 16.6697 20.4232V16.0267C16.6697 15.7505 16.4386 15.5265 16.1625 15.5289C6.08003 15.6185 2.78945 18.4118 4.14886 24.3336C4.25693 24.8044 3.55166 25.1495 3.31821 24.7266C-5.31296 9.09202 10.3535 6.93602 16.1673 6.88021C16.4458 6.87754 16.6697 6.65313 16.6697 6.37467V1.73482C16.6697 0.933997 17.564 0.458041 18.2283 0.905382Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoNonactive);
export default __webpack_public_path__ + "static/media/redo-nonactive.d48f60bacf0fdf2500e6dd67b579b530.svg";
export { ForwardRef as ReactComponent };